var map = {
	"./DanielMSousa.png": 744,
	"./Eduarda-Donato.png": 569,
	"./Joyce-Ribeiro.png": 121,
	"./Tiago Maritan.png": 431,
	"./biabcaval.png": 389,
	"./erlonL.png": 872,
	"./mariabandeira.png": 624,
	"./talesnobre.png": 897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;